import script from "./DropdownSearchableMultiple.vue?vue&type=script&setup=true&lang=ts"
export * from "./DropdownSearchableMultiple.vue?vue&type=script&setup=true&lang=ts"

import "./DropdownSearchableMultiple.vue?vue&type=style&index=0&id=8caf10de&lang=scss"

const __exports__ = script;

export default __exports__